import { Grid, html as htmlGrid } from 'gridjs'
import SelectMultiple from '../components/SelectMultiple'
import ModalResumo from '../components/ModalResumo.js'
import { capitalize, uniqBy } from 'lodash'
import { CONFIG_GRID_DEFAULT, MONTHS_LIST } from '../constants/reuniao.js'
import { MONTHS_LIST } from '../constants/reuniao.js'
import TableCalendarioReuniaoSai from '../components/TableCalendarioReuniaoSai.js'
import ModalFiltroCalendarioSai from '../components/ModalFiltroCalendarioSai.js'
import { reuniaoService } from '../services/reuniao.service.js'
import { URLS } from '../constants/urls.js'
import GraficoFundacoesReuniaoPeriodo from '../components/GraficoFundacoesReuniaoPeriodo.js'
import GraficoFundacoesReuniaoAtendimento from '../components/GraficoFundacoesReuniaoAtendimento.js'
import TableAtendimento from '../components/TableAtendimento.js'
import TableDistribuicaoAtendimento from '../components/TableDistribuicaoAtendimento.js'
import DrawerAtendimentoRapido from '../components/DrawerAtendimentoRapido.js'
import Loader from '../components/Loader.js'
import atendimentoRapido from '../mixins/atendimentoRapido.js'

const { getAtendimentoReuniaoSai } = reuniaoService()

export default {
	emits: [],
	props: {},
	components: {
		GraficoFundacoesReuniaoPeriodo,
		GraficoFundacoesReuniaoAtendimento,
		SelectMultiple,
		ModalResumo,
		ModalFiltroCalendarioSai,
		TableCalendarioReuniaoSai,
		TableDistribuicaoAtendimento,
		DrawerAtendimentoRapido,
		Loader,
	},
	mixins: [atendimentoRapido],
	data() {
		return {
			isChangeChartReuniaoPeriodo: false,
			filtroQuery: {
				distribuicao: null,
			},
			filtroModalCalendarioSai: {
				officers: [],
				// outros campos default se necessário
			},
			clientesSelecionados: new Set(),
			limparCheckboxesTimestamp: 0,
			reuniaoAtendimento: {
				data: [],
				isLoading: false,
				error: null,
			},
			queryTabelaPorPeriodo: {},
		}
	},
	computed: {
		periodoFormatado(){
			return this.filtroQuery.distribuicao || ""
		},
		labelInfoGraficoPeriodo() {
			if(this.isChangeChartReuniaoPeriodo){
				return 
			}
		},
		officersOptions() {
			// Extrai e formata os officers vindos da API para o select do modal
			const users = this.reuniaoAtendimento?.data?.results?.todos_users || []
			return users.map((user) => ({
				value: user.id,
				label: user.username,
			}))
		},
		totalSelecionado() {
			return this.clientesSelecionados.size
		},
		mostrarDrawer() {
			return this.totalSelecionado > 0
		},
		dadosPeriodoSelecionado() {
			if (
				!this.filtroQuery.distribuicao ||
				!this.reuniaoAtendimento.data?.clientes_sem_reuniao_por_periodo
			) {
				return null
			}

			const periodo = this.filtroQuery.distribuicao
			const dadosPeriodo =
				this.reuniaoAtendimento.data.clientes_sem_reuniao_por_periodo[periodo]

			return dadosPeriodo || null
		},
		totalPeriodoSelecionado() {
			return this.dadosPeriodoSelecionado?.total || 0
		},
		corPeriodoSelecionado() {
			const coresPorPeriodo = {
				'1-3 meses': '#18b25d', // Verde
				'4-6 meses': '#ffc107', // Amarelo
				'7-9 meses': '#ec3539', // Vermelho
				'10+ meses': '#ec3539', // Vermelho
			}
			return coresPorPeriodo[this.filtroQuery.distribuicao] || '#18b25d'
		},
		getParamsAPI() {
			const anoAtual = new Date().getFullYear()
			const params = {
				ano_inicio: 2024,
				mes_inicio_ano_inicial: '01',
				tem_atendimento: 'true',
				ano_fim: anoAtual,
				mes_fim_ano_final: '12',
				mes_inicio_ano_final: '1',
				mes_fim_ano_inicial: '12',
				page: 1,
				per_page: 999999,
			}

			// Período
			if (this.filtroQuery.distribuicao) {
				const mapeamentoPeriodos = {
					'1-3 meses': '1,3',
					'4-6 meses': '4,6',
					'7-9 meses': '7,9',
					'10+ meses': '10,9999',
				}
				params.meses = mapeamentoPeriodos[this.filtroQuery.distribuicao]
			}

			// Officers
			const officers = (this.filtroModalCalendarioSai.officers || []).map(
				(o) => o.value
			)
			if (officers.length === 1) {
				params.user = officers[0]
			} else if (officers.length > 1) {
				params.user = officers.join(',')
			}

			return params
		},
	},
	watch: {
		isChangeChartReuniaoPeriodo(newValue) {
			if (!newValue) {
				// Resetar filtro quando sair do modo detalhado
				this.filtroQuery.distribuicao = null
			} else {
				this.aplicaFiltrosTabelaDistribuicao()
			}
		},
	},
	methods: {
		aplicaFiltrosTabelaDistribuicao() {
			const query = {}

			// Filtro por período (meses)
			if (this.filtroQuery.distribuicao) {
				const mapeamentoPeriodos = {
					'1-3 meses': '1,3',
					'4-6 meses': '4,6',
					'7-9 meses': '7,9',
					'10+ meses': '10,999',
				}
				query.meses = mapeamentoPeriodos[this.filtroQuery.distribuicao]
			}

			// Filtro por officers (user)
			const officers = (this.filtroModalCalendarioSai.officers || []).map(
				(o) => o.value
			)
			if (officers.length === 1) {
				query.user = officers[0]
			} else if (officers.length > 1) {
				query.user = officers.join(',')
			}

			this.queryTabelaPorPeriodo = query
		},
		async limparFiltrosCalendarioSai() {
			this.filtroModalCalendarioSai = { officers: [] }
			this.aplicaFiltrosTabelaDistribuicao()
			// Requisição SEM officers, mas mantém período se estiver ativo
			this.reuniaoAtendimento.isLoading = true
			try {
				const { user, ...restoQuery } = this.queryTabelaPorPeriodo
				this.queryTabelaPorPeriodo = { ...restoQuery }
				const response = await getAtendimentoReuniaoSai(this.getParamsAPI)
				this.reuniaoAtendimento.data = response || response?.data || []
			} catch (error) {
				console.error('Erro ao limpar filtros:', error)
				this.reuniaoAtendimento.error = error
				this.reuniaoAtendimento.data = []
			} finally {
				this.reuniaoAtendimento.isLoading = false
			}
		},
		openModalFiltroCalendarioSai() {
			modal_padrao_vue.openModal('reunioes_calendario_sai')
		},

		async aplicarFiltrosCalendarioSai() {
			this.aplicaFiltrosTabelaDistribuicao()
			this.reuniaoAtendimento.isLoading = true
			try {
				const response = await getAtendimentoReuniaoSai(this.getParamsAPI)
				this.reuniaoAtendimento.data = response || response?.data || []
			} catch (error) {
				console.error('Erro ao aplicar filtros:', error)
				this.reuniaoAtendimento.error = error
				this.reuniaoAtendimento.data = []
			} finally {
				this.reuniaoAtendimento.isLoading = false
			}
		},
		async carregarReuniaoAtendimento(filtros = {}) {
			this.reuniaoAtendimento.isLoading = true
			this.reuniaoAtendimento.error = null

			try {
				const response = await getAtendimentoReuniaoSai(this.getParamsAPI)
				this.reuniaoAtendimento.data = response || response?.data || []
			} catch (error) {
				console.error('Erro ao carregar reunião atendimento:', error)
				this.reuniaoAtendimento.error = error
				this.reuniaoAtendimento.data = []
			} finally {
				this.reuniaoAtendimento.isLoading = false
			}
		},

		async toggleChangeChartReuniaoPeriodo(chartEventoInfo) {
			this.isChangeChartReuniaoPeriodo = !this.isChangeChartReuniaoPeriodo

			if (this.isChangeChartReuniaoPeriodo) {
				this.filtroQuery.distribuicao =
					chartEventoInfo?.categoria ||
					this.filtroQuery?.distribuicao ||
					'4-6 meses'
				try {
					this.reuniaoAtendimento.isLoading = true
					const response = await getAtendimentoReuniaoSai(this.getParamsAPI)
					if (
						this.reuniaoAtendimento.data &&
						response &&
						response.meses_clientes_sem_reuniao
					) {
						this.reuniaoAtendimento.data = {
							...this.reuniaoAtendimento.data,
							meses_clientes_sem_reuniao: response.meses_clientes_sem_reuniao,
						}
					}
				} catch (error) {
					console.error('Erro ao filtrar gráfico de atendimento:', error)
				} finally {
					this.reuniaoAtendimento.isLoading = false
				}
			} else {
				this.filtroQuery.distribuicao = null
				const { meses, ...restoQuery } = this.queryTabelaPorPeriodo
				this.queryTabelaPorPeriodo = { ...restoQuery }
				await this.carregarReuniaoAtendimento()
			}
		},

		handleClienteChecked(idCliente) {
			this.clientesSelecionados.add(idCliente)
		},

		handleClienteUnchecked(idCliente) {
			this.clientesSelecionados.delete(idCliente)
		},

		handleClearClientes() {
			this.clientesSelecionados.clear()
			this.limparCheckboxesTimestamp = Date.now()
		},

		async criarAtendimentoRapido(politicaId, mensagem) {
			if (!politicaId || this.clientesSelecionados.size === 0) {
				return
			}

			this.loadingAtendimentoRapido = true

			try {
				// Adiciona os clientes selecionados ao mixin
				this.clearClienteAtendimentoRapido()
				Array.from(this.clientesSelecionados).forEach((id) =>
					this.addClienteAtendimentoRapido(id)
				)

				// Chama o método do mixin para criar o atendimento rápido
				await this.createAtendimentoRapido(
					politicaId,
					mensagem,
					'Atendimento Rápido',
					null // data opcional
				)

				// Limpa seleção após sucesso
				this.handleClearClientes()
			} catch (error) {
				console.error('Erro ao criar atendimento:', error)
			} finally {
				this.loadingAtendimentoRapido = false
			}
		},
	},
	async mounted() {
		await this.carregarReuniaoAtendimento()
	},
	delimiters: ['{*', '*}'],
}
